import styled from 'styled-components';

import { mediaQueryMobileMin } from 'styles/variables';

export const Arrow = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  border: 5px solid transparent;
`;

export const Wrapper = styled.div`
  background: #000;
  border-radius: 2px;
  border: 1px solid black;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.14);
  color: #fff;
  font-size: 12px;
  height: auto;
  left: ${({ left }) => `${left}px`};
  line-height: 16px;
  min-width: ${({ width }) => (width ? `${width}px` : '190px')};
  opacity: 1;
  padding: 10px 14px;
  position: fixed;
  top: ${({ top }) => `${top}px`};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  width: ${({ width }) => (width ? `${width}px` : '190px')};
  z-index: 1003;
  text-align: start;

  @media all and ${mediaQueryMobileMin} {
    min-width: ${({ width }) => (width ? `${width}px` : '240px')};
    width: ${({ width }) => (width ? `${width}px` : '240px')};
  }

  ${({ fixedPosition }) => {
    if (fixedPosition) {
      return `
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      `;
    }

    return '';
  }}

  ${Arrow} {
    ${({ position, arrowOffset }) => {
      if (position === 'top') {
        return `
            transform: translateX(-50%);
            top: auto;
            bottom: -5px;
            left: ${arrowOffset ? `${arrowOffset}%` : '50%'};
            border-bottom: none;
            border-top-color: #000;
          `;
      }

      if (position === 'bottom') {
        return `
            transform: translateX(-50%);
            top: -5px;
            bottom: auto;
            left: ${arrowOffset ? `${arrowOffset}%` : '50%'};
            border-top: none;
            border-bottom-color: #000;
          `;
      }

      if (position === 'left') {
        return `
            transform: translateY(-50%);
            right: -5px;
            left: auto;
            top: ${arrowOffset ? `${arrowOffset}%` : '50%'};
            border-right: none;
            border-left-color: #000;
          `;
      }

      if (position === 'right') {
        return `
            transform: translateY(-50%);
            left: -5px;
            right: auto;
            top: ${arrowOffset ? `${arrowOffset}%` : '50%'};
            border-left: none;
            border-right-color: #000;
          `;
      }

      return '';
    }}
  }
`;
